import React, { useState } from "react";
import {
  IconFilter,
  IconFireCircle,
  IconMapMarkerCircle,
  IconReset,
  IconSnowFlake,
  IconSnowFlakeCircle,
  IconTags,
  IconTimesThin,
  IconTwoBarsCircle,
  IconWarningCircle,
  IconWeightToolCircle,
} from "../../../common/icons/index";

const TrackOsImportAvailabilityFilterPop = (props) => {
  const { hideFilter } = props;
  const [showFilterTabs, setshowFilterTabs] = useState(1);
  const [subCardActive, setsubCardActive] = useState(false);

  const handleSubCardActive = (i) => {
    setsubCardActive(!subCardActive);
  };

  const handleFilterTabs = (i) => {
    setshowFilterTabs(showFilterTabs === i ? null : i);
  };
  return (
    <React.Fragment>
      <div className="bdpopup-backdrop"></div>
      <div className="bdpopup">
        <div className="bdpopup__content">
          <button
            className="btn btn-none bdpopup__close text-white"
            onClick={hideFilter}
          >
            <IconTimesThin className="close-icon" />
          </button>
          <div className="d-flex px-30 align-items-center justify-content-between pt-20">
            <p className="font-20 mb-0">Filters & Settings</p>
            <button className="btn btn-outline-light btn-sm mr-2">
              <IconReset className="mr-2" />
              Reset
            </button>
          </div>
          <ul
            className="nav nav-tabs nav-tabs-custom nav-justified nav-tabs-bottom-border mt-10"
            role="tablist"
          >
            <li className="nav-item">
              <a
                className={`nav-link ${showFilterTabs === 1 ? "active" : ""}`}
                href="javascript:void(0)"
                onClick={() => handleFilterTabs(1)}
              >
                <IconTags className="mr-1" />
                Subacards
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${showFilterTabs === 2 ? "active" : ""}`}
                href="javascript:void(0)"
                onClick={() => handleFilterTabs(2)}
              >
                <IconFilter className="mr-1" />
                Filters
              </a>
            </li>
          </ul>

          {showFilterTabs === 1 && (
            <div
              className="px-30 bdpopup__content__scroll"
              style={{ height: "calc(100% - 108px)" }}
            >
              <div className="mt-20">
                <h5>Customer</h5>
                <div className="form-row-sm">
                  <div className="col-md-6 mb-1">
                    <button
                      className={`subcard-item w-100 d-flex align-items-center ${
                        subCardActive && "subcard-item--active"
                      }`}
                      onClick={handleSubCardActive}
                    >
                      ABC Distibution
                      <span className="ml-auto">42</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      APM Consi
                      <span className="ml-auto">55</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Home Depot
                      <span className="ml-auto">42</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Interline
                      <span className="ml-auto">32</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      National Retail Store
                      <span className="ml-auto">39</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Noatum logistics
                      <span className="ml-auto">60</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      OEC Group
                      <span className="ml-auto">46</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Tom Details
                      <span className="ml-auto">76</span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-20">
                <h5>Port</h5>
                <div className="form-row-sm">
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      APM
                      <span className="ml-auto">17</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      National Retail Store
                      <span className="ml-auto">56</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Terminal
                      <span className="ml-auto">30</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Everport
                      <span className="ml-auto">28</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      GCT Bayonne
                      <span className="ml-auto">80</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      WBCT
                      <span className="ml-auto">15</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Maher Terminal
                      <span className="ml-auto">48</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      ITS - Pier G<span className="ml-auto">42</span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-20">
                <h5>Return</h5>
                <div className="form-row-sm">
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      APM
                      <span className="ml-auto">70</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      SSA - PIER A<span className="ml-auto">55</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Everport
                      <span className="ml-auto">22</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Terminal
                      <span className="ml-auto">41</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      GCT Bayonne
                      <span className="ml-auto">23</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      WBCT
                      <span className="ml-auto">53</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      PNCT
                      <span className="ml-auto">32</span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-20">
                <h5>Readiness for Pick Up</h5>
                <div className="form-row-sm">
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Ready
                      <span className="ml-auto">48</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Not Ready
                      <span className="ml-auto">50</span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-20">
                <h5>Consignee</h5>
                <div className="form-row-sm">
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      ABC Distibution
                      <span className="ml-auto">53</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Accem Warehouse
                      <span className="ml-auto">45</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Home Depot
                      <span className="ml-auto">74</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Amalgamed Textiles
                      <span className="ml-auto">45</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Interline
                      <span className="ml-auto">23</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      National Retail Store
                      <span className="ml-auto">33</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      Perfect Christmas Trees
                      <span className="ml-auto">65</span>
                    </button>
                  </div>
                  <div className="col-md-6 mb-1">
                    <button className="subcard-item w-100 d-flex align-items-center">
                      NRS Warehouse
                      <span className="ml-auto">50</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showFilterTabs === 2 && (
            <React.Fragment>
              <div
                className="px-30 bdpopup__content__scroll"
                style={{ height: "calc(100% - 182px)" }}
              >
                <React.Fragment>
                  <div className="form-group form-row mt-20">
                    <label className="col-md-5 col-form-label">
                      Pickup APT From
                    </label>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Select Pickup APT from date"
                      ></input>
                    </div>
                  </div>
                  <div className="form-group form-row">
                    <label className="col-md-5 col-form-label">
                      Pickup APT From
                    </label>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Select Pickup APT from date"
                      ></input>
                    </div>
                  </div>
                </React.Fragment>
                <div className="hr-light"></div>
                <React.Fragment>
                  <div className="form-group form-row">
                    <label className="col-md-5 col-form-label">
                      Trade Type
                    </label>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Select..."
                      ></input>
                    </div>
                  </div>
                  <div className="form-group form-row">
                    <label className="col-md-5 col-form-label">Origin</label>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Select..."
                      ></input>
                    </div>
                  </div>
                  <div className="form-group form-row">
                    <label className="col-md-5 col-form-label">
                      Destination
                    </label>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Select..."
                      ></input>
                    </div>
                  </div>
                  <div className="form-group form-row">
                    <label className="col-md-5 col-form-label">
                      Current Location
                    </label>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Select..."
                      ></input>
                    </div>
                  </div>
                  <div className="form-group form-row">
                    <label className="col-md-5 col-form-label">Added By</label>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Select..."
                      ></input>
                    </div>
                  </div>
                  <div className="form-group form-row">
                    <label className="col-md-5 col-form-label">Status</label>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Select..."
                      ></input>
                    </div>
                  </div>
                  <div className="form-group form-row">
                    <label className="col-md-5 col-form-label">Holds</label>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Select..."
                      ></input>
                    </div>
                  </div>
                </React.Fragment>
                <div className="hr-light"></div>
                <React.Fragment>
                  <div className="form-group form-row">
                    <label className="col-md-5 col-form-label">
                      Container Type
                    </label>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Select"
                      ></input>
                    </div>
                  </div>
                  <div className="form-group form-row">
                    <label className="col-md-5 col-form-label">
                      Container Size
                    </label>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Select"
                      ></input>
                    </div>
                  </div>
                  <div className="form-group form-row">
                    <label className="col-md-5 col-form-label">SSL</label>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Select"
                      ></input>
                    </div>
                  </div>
                  <div className="form-group form-row">
                    <label className="col-md-5 col-form-label">Voyage</label>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Select"
                      ></input>
                    </div>
                  </div>

                  <div className="form-group form-row">
                    <label className="col-md-5 col-form-label">Vessel</label>
                    <div className="col-md-7">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Select"
                      ></input>
                    </div>
                  </div>
                  <div className="form-group form-row">
                    <label className="col-md-5 col-form-label">Fees</label>
                    <div className="col-md-7 d-flex">
                      <div className="form-check pr-30">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="yes"
                        />
                        <label className="form-check-label" for="yes">
                          Yes
                        </label>
                      </div>
                      <div className="form-check pr-30">
                        <input
                          className="form-check-input"
                          type="radio"
                          id="no"
                        />
                        <label className="form-check-label" for="no">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              </div>
              <div className="bdpopup__footer page-fluid">
                <button className="btn btn-primary btn-block">Apply</button>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default TrackOsImportAvailabilityFilterPop;
